import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import api from '../lib/api';
import { formatIDR, formatDateTime } from '../lib/format';
import MemberLayout from '../components/MemberLayout';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from '../components/ui/dialog';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/table';
import { StatusBadge } from '../components/StatusBadge';

const WALLET_LABELS = { MEMBERSHIP_PAYMENT: 'Membership Payment', PRACTICE_ALLOCATION: 'Practice Allocation', PRACTICE_BALANCE: 'Trading Practice Balance', REFERRAL_COMMISSION: 'Referral Commission', WITHDRAWABLE: 'Withdrawable' };

export default function WalletPage() {
  const [wallets, setWallets] = useState({});
  const [ledger, setLedger] = useState([]);
  const [withdrawals, setWithdrawals] = useState([]);
  const [form, setForm] = useState({ amount: '', bank_name: '', bank_account_number: '', bank_account_holder: '' });
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const load = () => {
    api.get('/wallet').then(r => setWallets(r.data.wallets)).catch(()=>{});
    api.get('/wallet/ledger').then(r => setLedger(r.data.ledger)).catch(()=>{});
    api.get('/withdrawals/me').then(r => setWithdrawals(r.data.withdrawals)).catch(()=>{});
  };
  useEffect(() => { load(); }, []);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async () => {
    setLoading(true);
    try {
      await api.post('/withdrawals', { ...form, amount: parseInt(form.amount) });
      toast.success('Permintaan penarikan dikirim'); setOpen(false); setForm({ amount: '', bank_name: '', bank_account_number: '', bank_account_holder: '' }); load();
    } catch (e) { toast.error(e.response?.data?.detail || 'Gagal'); } finally { setLoading(false); }
  };

  return (
    <MemberLayout>
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h1 className="font-display text-2xl sm:text-3xl font-bold">Wallet & Ledger</h1>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button className="bg-[hsl(var(--brand-ink))] text-white" data-testid="open-withdraw-button">Tarik Komisi</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Tarik Komisi Referral</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>Jumlah (IDR)</Label><Input type="number" value={form.amount} onChange={set('amount')} className="mt-1.5" data-testid="withdraw-amount-input" /></div>
              <div><Label>Nama Bank</Label><Input value={form.bank_name} onChange={set('bank_name')} className="mt-1.5" /></div>
              <div><Label>No. Rekening</Label><Input value={form.bank_account_number} onChange={set('bank_account_number')} className="mt-1.5" /></div>
              <div><Label>Atas Nama</Label><Input value={form.bank_account_holder} onChange={set('bank_account_holder')} className="mt-1.5" /></div>
            </div>
            <DialogFooter><Button onClick={submit} disabled={loading} data-testid="withdraw-submit-button">{loading ? 'Memproses...' : 'Kirim Permintaan'}</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 mt-6">
        {Object.entries(WALLET_LABELS).map(([k,label]) => (
          <Card key={k} className="p-5"><div className="text-sm text-muted-foreground">{label}</div><div className="font-display text-xl font-bold mt-1 tabular-nums">{formatIDR(wallets[k] || 0)}</div></Card>
        ))}
      </div>

      {withdrawals.length > 0 && (
        <Card className="p-5 mt-6">
          <h3 className="font-semibold mb-3">Penarikan Saya</h3>
          <Table><TableHeader><TableRow><TableHead>Jumlah</TableHead><TableHead>Biaya</TableHead><TableHead>Bank</TableHead><TableHead>Status</TableHead></TableRow></TableHeader>
            <TableBody>{withdrawals.map(w => (<TableRow key={w.withdrawal_id}><TableCell className="tabular-nums">{formatIDR(w.amount)}</TableCell><TableCell className="tabular-nums">{formatIDR(w.fee)}</TableCell><TableCell>{w.bank_name}</TableCell><TableCell><StatusBadge status={w.status} /></TableCell></TableRow>))}</TableBody>
          </Table>
        </Card>
      )}

      <Card className="p-5 mt-6">
        <h3 className="font-semibold mb-3">Financial Ledger</h3>
        {ledger.length === 0 ? <p className="text-sm text-muted-foreground">Belum ada transaksi.</p> : (
          <div className="overflow-x-auto"><Table><TableHeader><TableRow><TableHead>Tipe</TableHead><TableHead>Wallet</TableHead><TableHead>Arah</TableHead><TableHead className="text-right">Jumlah</TableHead><TableHead>Waktu</TableHead></TableRow></TableHeader>
            <TableBody>{ledger.map(t => (<TableRow key={t.transaction_id}><TableCell className="text-xs">{t.type}</TableCell><TableCell className="text-xs">{WALLET_LABELS[t.wallet]||t.wallet}</TableCell><TableCell><span className={t.direction==='CREDIT'?'text-emerald-600':'text-red-600'}>{t.direction}</span></TableCell><TableCell className="text-right tabular-nums">{formatIDR(t.amount)}</TableCell><TableCell className="text-xs text-muted-foreground">{formatDateTime(t.created_at)}</TableCell></TableRow>))}</TableBody>
          </Table></div>
        )}
      </Card>
    </MemberLayout>
  );
}
